import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { Link as RouterLink } from 'react-router-dom';

import { routes } from '../../../constants.js/misc';

//ICONS
import HomeIcon from '../../../assets/icons/HomeIcon.svg';
import AddProductIcon from '../../../assets/icons/add-product.svg';
import OrdersIcon from '../../../assets/icons/OrderIcon.svg';
import CategoryIcon from '../../../assets/icons/CategoryIcon.svg';
import GearIcon from '../../../assets/icons/GearIcon.svg';
import { colors } from '../../../constants.js/colors';

//Styles Components
const footerStyles = makeStyles({
    footer: {
        position: 'fixed',
        width: '100%',
        bottom: 0,
        height: 58,
        background: 'white'
    },
    container: {
        margin: '5px auto 0 auto',
    },
    icon: {
        display: 'block',
        margin: '0 auto',
        width: '100%',
        height: 21,
    },
    active: {
        display: 'block',
        margin: '0 auto',
        width: '100%',
        height: 21,
        color: colors.neutral[600],
    },
    text: {
        margin: '5px auto 0 auto',
        color: '#0f2930',
        "&:hover": {
            textDecoration: 'none !important'
        },
        textAlign: 'center',
    },
    iconAdd: {
        height: '70px',
        marginTop: '-50px'
    }
})

const activeLinkStyles = (url) => {
    return window.location.pathname.includes(url)
}

export const FooterBar = () => {
    const classes = footerStyles();
    const { t } = useTranslation();

    return (
        <footer className={classes.footer}>
            <Grid item container xs={12}>
                <Grid item container xs={2} className={classes.container}>
                    <Link
                        className={classes.text}
                        component={RouterLink}
                        to={routes.homeUrl}>
                        <img src={HomeIcon} className={activeLinkStyles(routes.homeUrl) ? classes.active : classes.icon} />
                        <Typography variant="caption">
                            {t('MobileFooter.inicio')}
                        </Typography>
                    </Link>
                </Grid>
                <Grid item container xs={2} className={classes.container}>
                    <Link
                        className={classes.text}
                        component={RouterLink}
                        to={routes.productsTable}>
                        <img src={OrdersIcon} className={activeLinkStyles(routes.productsTable) ? classes.active : classes.icon} />
                        <Typography variant="caption">
                            {t('ProductsTitle')}
                        </Typography>
                    </Link>
                </Grid>
                <Grid item container xs={3} className={classes.container}>
                    <Link
                        className={classes.text}
                        component={RouterLink}
                        to={routes.createProduct}>
                        <img src={AddProductIcon} className={classes.iconAdd} />
                        <Typography variant="caption">
                            {t('Product.createButton')}
                        </Typography>
                    </Link>
                </Grid>
                <Grid item container xs={2} className={classes.container}>
                    <Link
                        className={classes.text}
                        component={RouterLink}
                        to={routes.mobileManageCategories}>
                        <img src={CategoryIcon} className={activeLinkStyles(routes.mobileManageCategories) ? classes.active : classes.icon} />
                        <Typography variant="caption">
                            {t('MobileDrawer.categories')}
                        </Typography>
                    </Link>
                </Grid>
                <Grid item container xs={2} className={classes.container}>
                    <Link
                        className={classes.text}
                        component={RouterLink}
                        to={routes.config}>
                        <img src={GearIcon} className={activeLinkStyles(routes.config) ? classes.active : classes.icon} />
                        <Typography variant="caption">
                            {t('MobileFooter.settings')}
                        </Typography>
                    </Link>
                </Grid>
            </Grid>
        </footer >

    );
}

export default connect()(FooterBar);